export { default } from './HowQrWorksView';



// WEBPACK FOOTER //
// ./src/components/views/HowQrWorksView/index.js